import React from 'react';

const KenaikanGaji = () => {
  return (
    <h1>Kenaikan Gaji</h1>
  );
};

export default KenaikanGaji;





